import "../style.css";
import MessageModal from "../../../../components/modal/MessageModal";
import { ModalButton, ModalButtonRow } from "../../../../components/modal/ModalButtons";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { ChecklistIcon } from "../../../../components/icons";

// "カートに追加しました" popup. Its look (MessageModal + ModalButton) is the
// reference for every customer popup — My Page uses the same pieces.
const ConfirmationModal = ({
    show,
    onClose,
    cartItem,
    pickupDateTime,
    lang,
    addToCart,
    submitCheckout
}) => {
    const { t, i18n } = useTranslation();
    const dateFormat = {
        "EN": "MMMM Do, YYYY",
        "JP": "YYYY年MM月DD日"
    }
    return (
        <MessageModal
            show={show}
            onClose={onClose}
            icon={ChecklistIcon}
            title={t("BookingConfirmation.ConfirmationModal.title")}
            messageHtml={t("BookingConfirmation.ConfirmationModal.message", {
                honorific: cartItem.passengerPronounced,
                customerName: cartItem.passengerName,
                pickupHour: moment(cartItem.pickupDateTime).format("HH:mm"),
                formattedPickup: moment(pickupDateTime).format(dateFormat[lang.toUpperCase()]),
                pickupLocation: cartItem.pickupLocation.label.split(',')[0],
            })}
        >
            <ModalButtonRow>
                <ModalButton
                    variant="secondary"
                    onClick={() => {
                        addToCart(i18n.language === "en" || i18n.language === "EN" ? "/en/book" : "/jp/book");
                    }}
                >
                    {t("BookingConfirmation.ConfirmationModal.addAnotherBooking")}
                </ModalButton>
                <ModalButton variant="primary" onClick={() => addToCart("/Cart")}>
                    {t("BookingConfirmation.ConfirmationModal.proceedToCart")}
                </ModalButton>
            </ModalButtonRow>

            <div className="tw:flex tw:items-center tw:justify-center tw:gap-3 tw:mt-3">
                <hr className="tw:flex-1 tw:!border-[#D9D9D9]" />
                <p className="tw:whitespace-nowrap tw:m-0 tw:!font-[400] tw:!text-[#282828]">
                    {t("BookingConfirmation.ConfirmationModal.or")}
                </p>
                <hr className="tw:flex-1 tw:!border-[#D9D9D9]" />
            </div>

            <div className="tw:flex tw:mt-2 tw:justify-center tw:pb-4 tw:md:pb-0">
                <ModalButton variant="secondary" onClick={() => submitCheckout()}>
                    {t("BookingConfirmation.ConfirmationModal.bookThisTransferOnly")}
                </ModalButton>
            </div>
        </MessageModal>
    )
}

export default ConfirmationModal
